import { render, staticRenderFns } from "./EdicaoEscritorioUsuario.vue?vue&type=template&id=3161575c&scoped=true"
import script from "./EdicaoEscritorioUsuario.vue?vue&type=script&lang=js"
export * from "./EdicaoEscritorioUsuario.vue?vue&type=script&lang=js"
import style0 from "./EdicaoEscritorioUsuario.vue?vue&type=style&index=0&id=3161575c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3161575c",
  null
  
)

export default component.exports